/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { createReducer, Action, on } from '@ngrx/store';
import {
  generateNewRecommendationRandomId,
  resetRecommendationRandomIds,
  resetShareRecommendation,
  setDisplayVetComments,
  setShareRecommendation,
  setVetComments,
} from './share-recommendation.actions';
import { initialShareRecommendationState, ShareRecommendationState } from './share-recommendation.state';

const _shareRecommendationReducer = createReducer(
  initialShareRecommendationState,
  on(
    setShareRecommendation,
    (state, { data }): ShareRecommendationState => ({
      ...state,
      data,
    }),
  ),
  on(resetShareRecommendation, (state) => {
    return { ...state, data: null };
  }),
  on(generateNewRecommendationRandomId, (state, { id, flowId, randomId }) => {
    const recommendationId = { id, flowId, randomId };
    return {
      ...state,
      randomRecommendationIds: [...state.randomRecommendationIds, recommendationId],
    };
  }),
  on(resetRecommendationRandomIds, (state) => {
    return {
      ...state,
      randomRecommendationIds: [],
    };
  }),
  on(setVetComments, (state, { vetComments }) => {
    return {
      ...state,
      data: state.data ? { ...state.data, vetComments } : null,
    };
  }),
  on(setDisplayVetComments, (state, { displayVetComments }) => {
    return {
      ...state,
      data: state.data ? { ...state.data, displayVetComments } : null,
    };
  }),
);

export function shareRecommendationReducer(state: ShareRecommendationState | undefined, action: Action) {
  return _shareRecommendationReducer(state, action);
}
